import clsx from 'clsx';
import React from 'react';

interface PageSectionProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function PageSection({
  children,
  className,
  onClick,
}: Readonly<PageSectionProps>) {
  return (
    <div
      className={clsx('flex-grow p-2 overflow-y-auto rounded-xl', className)}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
